export default {
  translation: {
    common: {
      emailOrUsername: 'Email yoki foydalanuvchi nomi',
      invalidUsernameOrPassword: "Noto'g'ri foydalanuvchi nomi yoki parol",
      logInToBoards: 'ga Kirish',
      noInternetConnection: "Internet bog'lanishi yo'q",
      pageNotFound_title: 'Sahifa Topilmadi',
      password: 'Parol',
      serverConnectionFailed: "Serverga bog'lanish xatosi",
      unknownError: "Noma'lum xatolik, qaytadan urinib ko'ring",
    },

    action: {
      logIn: 'Kirish',
    },
  },
};
